import { Card, CardBody, Col, Table, Button, Container, Row } from "reactstrap";
import TabPlusIcon from "mdi-react/TabPlusIcon";
import { useHistory } from "react-router";
import UserDesignationTable from "./UserDesignationTable";
import { decryption } from "../HelperFunctions";
import BreadCrumb from "../../shared/components/BreadCrumb/BreadCrumb";

const UserDesignation = () => {
  const history = useHistory();
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "User Designation ",
    },
  ];
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <BreadCrumb breadCrumbData={breadCrumbData} />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">User Designation List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {permissions?.includes("create_designation") && (
                <Button
                  onClick={() => history.push("/user/new-designation")}
                  color="primary"
                >
                  <TabPlusIcon className="mr-1" />
                  New Designation
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <UserDesignationTable />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserDesignation;
